/* =============================================================
   FLARE — Theme JavaScript
   ============================================================= */

(function () {
  'use strict';

  /* ── Header scroll state ─────────────────────────────────── */
  const header = document.querySelector('.flare-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav toggle ───────────────────────────────────── */
  const mobileToggle = document.querySelector('.nav-mobile-toggle');
  const mobileMenu   = document.querySelector('.mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Email form submission (mid-page capture) ────────────── */
  document.querySelectorAll('.email-form, .footer-email-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input  = form.querySelector('input[type="email"]');
      const btn    = form.querySelector('button[type="submit"], .footer-email-btn');
      const email  = input?.value?.trim();

      if (!email || !isValidEmail(email)) {
        showFormMessage(form, 'Please enter a valid email address.', 'error');
        return;
      }

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Sending…';
      }

      try {
        // Shopify Customer Subscribe API
        const formData = new FormData();
        formData.append('customer[email]', email);
        formData.append('customer[tags]', 'newsletter,flare-signup');

        const resp = await fetch('/contact#contact_form', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new URLSearchParams({ 'contact[email]': email, 'form_type': 'customer' }),
        });

        showFormMessage(form, "You're in. Welcome to the heat.", 'success');
        if (input) input.value = '';
      } catch (err) {
        showFormMessage(form, 'Something went sideways. Try again.', 'error');
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.originalText || 'Join';
        }
      }
    });
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showFormMessage(form, text, type) {
    let msg = form.querySelector('.form-message');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'form-message';
      form.appendChild(msg);
    }
    msg.textContent = text;
    msg.style.cssText = `
      font-size: 0.8rem;
      margin-top: 0.5rem;
      color: ${type === 'success' ? 'var(--cream-light)' : '#ffb3a0'};
      font-weight: 500;
    `;
    if (type === 'success') {
      setTimeout(() => msg.remove(), 6000);
    }
  }

  /* ── Product quick-add ───────────────────────────────────── */
  document.querySelectorAll('.btn-quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        btn.textContent = 'Added ✓';
        updateCartCount();
        await fetch('/cart.js').then(r=>r.json()).then(()=>{ window.location='/cart'; });

        setTimeout(() => {
          btn.textContent = 'Quick Add';
          btn.disabled = false;
        }, 2000);
      } catch {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      document.querySelectorAll('.nav-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch {}
  }

  /* ── Scroll reveal ───────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('revealed'));
  }

  /* ── Init cart count on load ─────────────────────────────── */
  updateCartCount();

})();
